__turbopack_context__.v({
  "asset": "Hero3-module__9rsuBq__asset",
  "button": "Hero3-module__9rsuBq__button",
  "buttonWrapper": "Hero3-module__9rsuBq__buttonWrapper",
  "link": "Hero3-module__9rsuBq__link",
  "noLineClamp": "Hero3-module__9rsuBq__noLineClamp",
  "preamble": "Hero3-module__9rsuBq__preamble",
  "root": "Hero3-module__9rsuBq__root",
  "text": "Hero3-module__9rsuBq__text",
  "title": "Hero3-module__9rsuBq__title",
});
